<template>
  <ws-list-view-item-column v-if="item">
    <div class="ws-participants__item">
      <figure class="ws-participants__item-avatar image is-128x128">
        <ws-avatar
          v-if="item.user_info"
          :id="item.user_info.guid"
          :name="userFullName"
          sizeType="Small"
          :size="128"
        />
      </figure>
      <div class="ws-participants__item-name">
        <a
          class="has-text-black"
          :href="profileLink"
          v-if="item.user_info"
          target="_blank"
        >
          {{ userFullName }}
        </a>
        <span v-if="item.user_info !== null && item.user_info.profile_stat">
          <b-tooltip
            :position="'is-bottom'"
            :label="tooltipMessage"
            :type="profileStatCompleted && isUserAgreement ? 'is-success' : 'is-danger'"
            multilined
          >
            <ws-dot-status :type="profileStatCompleted && isUserAgreement ? 'success' : 'danger'" />
          </b-tooltip>
        </span>
      </div>
      <div class="ws-participants__item-email">
        <span
          class="has-text-primary"
          v-if="item.user_info"
        >
          <b-tooltip
            v-if="isActive.msg"
            position="is-bottom"
            :label="isActive.msg"
            :type="isActive.type"
            multilined
          >
            <span
              class="email-active"
              v-if="isActive.active"
            >
              {{item.user_info.email}}
            </span>
            <span
              v-else
              class="email-inactive"
            >{{item.user_info.email}}</span>
          </b-tooltip>
        </span>
        <span v-else>
          <a
            class="has-text-black"
            :href="profileLink"
            target="_blank"
          >
            Информация об участнике отсутствует
          </a>
        </span>
      </div>
      <div
        class="ws-participants__item-type has-text-right-desktop"
        v-text="$t('Участник')"
      ></div>
      <WsParticipantsPersonalData :userInfo="item.user_info" :changeUserAgreement="changeUserAgreement"/>
      <div class="ws-participants__item-status">
        <!--Профиль не заполнен-->
      </div>
      <div class="ws-participants__item-action">
        <template v-if="isParticipantInExamGroup && item.user_info != null">
          <b-tooltip
            multilined
            position="is-left"
            type="is-dark"
            size="is-small"
            class="is-fullwidth"
            :label="$t('Пользователь состоит в экзаменационной группе.')"
          >
            <button
              disabled
              class="ws-button button is-danger is-small has-text-white is-fullwidth"
              v-text="$t('Открепить от уч. группы')"
            ></button>
          </b-tooltip>
        </template>

        <template v-else>
          <button
            class="ws-button button is-danger is-small has-text-white is-fullwidth"
            @click="inputUsers(item)"
            v-text="$t('Открепить от уч. группы')"
          ></button>
        </template>
      </div>
<!--      <div class="ws-participants__item-details">-->
<!--        <details open>-->
<!--          <summary>Ускоренное обучение по индивидуальному учебному плану (изменены сроки ГИА)</summary>-->
          <WsParticipantsPersonalDetails :userInfo="item.user_info" :currentId="currentId"/>
<!--        </details>-->
<!--      </div>-->

    </div>
  </ws-list-view-item-column>
</template>

<script>
import { get } from 'lodash'
import WsDotStatus from '@/components/common/WsDotStatus'
import WsParticipantsPersonalData from '@/components/de/groups/WsParticipantsPersonalData.vue'
import WsParticipantsPersonalDetails from '@/components/de/groups/WsParticipantsPersonalDetails.vue'

const NULL_GUID = '00000000-0000-0000-0000-000000000000'

export default {
  name: 'ws-participants-list-item',
  components: {
    WsParticipantsPersonalData,
    WsParticipantsPersonalDetails,
    WsDotStatus
  },
  props: {
    item: {
      type: Object,
      default: () => null
    },
    currentId: String
  },
  data () {
    return {
      isUserAgreement: false
    }
  },
  computed: {
    profileLink () {
      if (!this.item.guid) {
        return ''
      }
      return `${__config.services.profile}/user/${this.item.guid}/`
    },
    isParticipantInExamGroup () {
      return this.item && this.item.exam_group_id !== NULL_GUID
    },
    isActive () {
      let msg = this.$t(`Почта не подтверждена.\nУчастнику направлено письмо с кодом подтверждения.`)
      let type = 'is-danger'
      let active = false

      if (!this.item.all_user_info) {
        msg = ''
        type = ''
      }

      const info = this.item.all_user_info

      if (info && info.activation_status && (info.activation_status === 'active' || info.activation_status === 'active_without_confirm')) {
        msg = this.$t('Почта подтверждена.')
        type = 'is-success'
        active = true
      }

      return { msg, type, active }
    },
    tooltipMessage () {
      return this.$t(`Профиль заполнен на ${this.item.user_info.profile_stat.percents}%${this.isUserAgreement ? '' : `\nЗагрузите скан-копию файла согласия\nна обработку персональных данных`}`)
    },
    profileStatCompleted () {
      return this.item.user_info.profile_stat.completed || false
    },
    userFullName () {
      const lastName = get(this.item, 'user_info.last.display', '')
      const firstName = get(this.item, 'user_info.first.display', '')
      const middleName = get(this.item, 'user_info.middle.display', '')

      const fullName = `${lastName} ${firstName} ${middleName}`
      return fullName.trim()
    }
  },
  methods: {
    changeUserAgreement (val) {
      this.isUserAgreement = val
    },
    inputUsers (user) {
      this.$emit('input-users', [user])
    }
  }
}
</script>
<style>
.b-tooltip:not([data-label=""]):hover:before, .b-tooltip:not([data-label=""]):hover:after {
  white-space: pre;
}
</style>

<style scoped lang="scss">
.ws-participants__item-email {
  cursor: pointer;
}
.ws-participants__item-email .email-inactive {
  color: #eb5757;
}
.ws-participants__item-email .email-active {
  color: #3f842f;
}

.ws-participants__list {
  overflow-x: visible;
  overflow-y: visible;
}

// .b-tooltip:after {
//   white-space: pre !important;
// }

.b-tooltip.is-bottom.is-multiline.is-medium:after {
  width: auto;
}

</style>
